module.exports = __webpack_public_path__ + "img/symbol_8.4e4f0936.png";